import { ACTION } from './action-types';
import * as actions from './action-types';
import { ActionMap } from 'app/area/my-downloads/types';
import { ReportsViewState } from 'app/area/my-downloads/reports-view/types-store';

export const INITIAL_REPORTS_VIEW_STATE: any = {
  reportsView: {
    download: undefined,
    fetchingReportStatus: false,
    reportStatus: undefined
  }
};

export const reducers: ActionMap = {

  [ACTION.REQUEST_REPORT_STATUS]: (state: ReportsViewState, action: actions.RequestReportStatus): ReportsViewState => {

    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        fetchingReportStatus: true
      }
    };
  },

  [ACTION.RECEIVE_REPORT_STATUS]: (state: ReportsViewState, action: actions.ReceiveReportStatus): ReportsViewState => {

    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        reportStatus: action.reportStatus,
        fetchingReportStatus: false
      }
    };
  },

  [ACTION.FAIL_REPORT_STATUS]: (state: ReportsViewState, action: actions.FailReportStatus): ReportsViewState => {

    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        fetchingReportStatus: false
      }
    };
  },

  [ACTION.REQUEST_DOWNLOAD_REPORT_PACKAGE]: (state: ReportsViewState,
    action: actions.RequestDownloadReportPackage): ReportsViewState => {
    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        download: {
          reportId: action.reportId,
          fetching: true
        }
      }
    };
  },

  [ACTION.RECEIVE_DOWNLOAD_REPORT_PACKAGE]: (state: ReportsViewState,
    action: actions.ReceiveDownloadReportPackage): ReportsViewState => {
    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        download: undefined
      }
    };
  },

  [ACTION.FAIL_DOWNLOAD_REPORT_PACKAGE]: (state: ReportsViewState,
    action: actions.FailDownloadReportPackage): ReportsViewState => {
    return {
      ...state,
      reportsView: {
        ...state.reportsView,
        download: undefined
      }
    };
  }
};
